// extracted by mini-css-extract-plugin
export var container = "_v8-0";
export var table = "_v8-2";
export var tableWrapper = "_v8-1";